import store from "@frameworks/web/redux/store";
import { MARKET_MAP_PL, MARKET_MAP_PL_ERROR, MARKET_MAP_PL_HIDE_ERROR, MARKET_MAP_PL_START_LOADER, MARKET_MAP_PL_STOP_LOADER, } from "../interface/IMarketMapPl";
class MarketMapPLActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getMarketMapPL(data) {
        this.dispatch({
            type: MARKET_MAP_PL,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: MARKET_MAP_PL_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: MARKET_MAP_PL_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: MARKET_MAP_PL_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: MARKET_MAP_PL_STOP_LOADER,
        });
    }
}
export default MarketMapPLActions;
